import MultiCascadeTree from './MultiCascadeTree';
export type { ItemDataType } from '@/internals/types';
export type { MultiCascadeTreeProps } from './types';

export default MultiCascadeTree;
